import { FETCHING_HYDRO_MODELS_FAILURE, FETCHING_HYDRO_MODELS_STARTED, FETCHING_HYDRO_MODELS_SUCCESS } from 'src/actions/HydroModelActions'
import { BaseAction, CallResult, DataAction, MessageAction } from 'src/CustomTypes'
import { HydroModelObject } from 'src/dataSources/geo/HydroModel'

export interface HydroModelState {
  fetchHydroModelsStatus: CallResult
  fetchHydroModelsError: string
  hydroModels: HydroModelObject[]
}

export const hydroModelStateInitial: HydroModelState = {
  fetchHydroModelsStatus: CallResult.Initial,
  fetchHydroModelsError: '',
  hydroModels: []
}

export function hydroModelReducer (
  state: HydroModelState = hydroModelStateInitial, // eslint-disable-line @typescript-eslint/default-param-last
  action: BaseAction
): HydroModelState {
  switch (action.type) {
    case FETCHING_HYDRO_MODELS_STARTED: {
      return {
        ...state,
        fetchHydroModelsStatus: CallResult.Running
      }
    }
    case FETCHING_HYDRO_MODELS_FAILURE: {
      const a = action as MessageAction
      return {
        ...state,
        fetchHydroModelsStatus: CallResult.Failed,
        fetchHydroModelsError: a.message
      }
    }
    case FETCHING_HYDRO_MODELS_SUCCESS: {
      const a = action as DataAction<HydroModelObject[]>
      return {
        ...state,
        fetchHydroModelsStatus: CallResult.Succeeded,
        hydroModels: a.data
      }
    }
    default:
      return state
  }
}
